'use client';

export { default } from './MenuList';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/MenuList/index.js
// module id = 173
// module chunks = 25